import { Incident } from '@silbo/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IncidentStepperLayout } from '../IncidentStepperLayout';
import { CommentStep } from '../steps/CommentStep';
import { DelayStep } from '../steps/DelayStep';
import { UnassignmentStep } from '../steps/UnassignmentStep';

type PatientNotReadyOrOtherValue = Partial<Pick<Incident, 'delayInMinutes' | 'unassignmentRequested' | 'comment'>>;

export function PatientNotReadyOrOther({
  reason,
  onBack,
  onComplete,
}: {
  reason: 'PATIENT_NOT_READY' | 'OTHER';
  onBack: () => void;
  onComplete: (value: PatientNotReadyOrOtherValue) => void;
}) {
  const { t } = useTranslation('patient-transport');

  const [value, setValue] = useState<PatientNotReadyOrOtherValue>({});

  const [activeStep, setActiveStep] = useState(0);

  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <DelayStep
            value={value.delayInMinutes}
            onChange={(delayInMinutes) => setValue({ ...value, delayInMinutes })}
          />
        );
      case 1:
        return (
          <UnassignmentStep
            value={value.unassignmentRequested}
            onChange={(unassignmentRequested) => setValue({ ...value, unassignmentRequested })}
          />
        );
      default:
        return (
          <CommentStep value={value.comment} onChange={(comment) => setValue({ ...value, comment })} incident={value} />
        );
    }
  };

  const isCurrentStepValid =
    activeStep === 0
      ? value.delayInMinutes !== undefined
      : activeStep === 1
        ? value.unassignmentRequested !== undefined
        : true;

  return (
    <IncidentStepperLayout
      title={t(`fareIncidents.${reason}` as unknown as TemplateStringsArray)}
      stepsLength={3}
      activeStep={activeStep}
      isCurrentStepValid={isCurrentStepValid}
      onPrevious={() => setActiveStep(activeStep - 1)}
      onNext={() => setActiveStep(activeStep + 1)}
      onBack={onBack}
      onComplete={() => onComplete(value)}
    >
      {renderStep()}
    </IncidentStepperLayout>
  );
}
